import React from "react";

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
      <div className="flex items-center justify-center mb-2">
        <span className="text-2xl mr-2">⚠️</span>
        <p className="text-red-600 font-medium">Attenzione</p>
      </div>
      <p className="text-red-500 text-sm">{message}</p>
    </div>
  );
};

export default ErrorMessage;
